/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AbcIcon = ({ width = 24, height = 24, hidden = false, title = 'Abc' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M7.78809,12.9678l-3.04688-7.5c-.23047-.56543-1.16016-.56543-1.39062,0L.30469,12.9678c-.15527.38379.0293.82129.41309.97705.09277.0376.1875.05518.28223.05518.2959,0,.57617-.17627.69531-.46777l.92676-2.28223h2.84839l.927,2.28223c.15723.38525.59473.56738.97754.4126.38379-.15576.56836-.59326.41309-.97705ZM3.125,10.00003l.9209-2.5625.92285,2.5625h-1.84375Z"
      fill="currentColor"
    />
    <path
      d="M11.03711,14.00003h-2.28711c-.41406,0-.75-.33594-.75-.75v-7.5c0-.41406.33594-.75.75-.75h1.6123c1.44629,0,2.5791,1.12891,2.5791,2.57031,0,.58936-.16406,1.11475-.45117,1.53467.67969.4834,1.12695,1.29541,1.12695,2.21436,0,1.47803-1.15723,2.68066-2.58008,2.68066ZM9.5,12.50003h1.53711c.5957,0,1.08008-.52979,1.08008-1.18066,0-.65137-.48438-1.18115-1.08008-1.18115h-1.53711v2.36182ZM9.5,8.93753h.95898c.59668,0,.98242-.5752.98242-1.22412,0-.62012-.4541-1.21338-1.0791-1.21338h-.8623v2.4375Z"
      fill="currentColor"
    />
    <path
      d="M17.87988,14.00003c-2.27734,0-4.12988-2.01855-4.12988-4.5,0-2.98047,2.65723-5.33984,5.52246-4.22168.38574.15088.57715.58594.42578.97168-.15039.38525-.58789.57617-.9707.42578-.30273-.11816-.58008-.17578-.84766-.17578-1.4502,0-2.62988,1.3457-2.62988,3s1.17969,3,2.62988,3c.26758,0,.54492-.05762.84766-.17578.38281-.14893.82031.04004.9707.42578.15137.38574-.04004.8208-.42578.97168-.47949.18701-.93457.27832-1.39258.27832Z"
      fill="currentColor"
    />
  </svg>`;
};
